/*
 *  Class ScrollTop
 */
export
default class ScrollTop {
    constructor() {
        this.scrollTop = document.querySelector('.go-top');
        this.header = document.querySelector('.header');
    }

    init() {
        if (!this.scrollTop) return;
        window.addEventListener('scroll', function () {
            if (window.scrollY > this.header.offsetHeight) {
                this.scrollTop.classList.add('is-visible');

            } else {
                this.scrollTop.classList.remove('is-visible');
            }
        }.bind(this));

        this.scrollTop.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }.bind(this));
    }
}
